export default __webpack_public_path__ + "static/taskdefinition22-245d10ba8779cc36c15013f92bfabece.png";